<template>
  <div class="recharge_wrap finance-page wallet-add-page">
    <div class="red_top_bg wallet-header">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('account.addAccount') }}
      </div>
    </div>
    <div class="wrap_box warp1 wallet-form">
      <div class="item">
        <div class="ari_font">
          {{ $t('account.bank') }}：
        </div>
        <van-dropdown-menu :overlay="false">
          <van-dropdown-item
            v-model="value"
            :options="wallets"
            @change="onChange()"
          />
        </van-dropdown-menu>
      </div>
      <!-- 虚拟货币 -->
      <div v-show="bank.type == 1">
        <div class="item">
          <div class="ari_font">
            {{ $t('account.address') }}：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            :placeholder="$t('account.addressTit')"
          >
        </div>
        <!-- <div class="qrcode">
					<div>{{$t('account.qrcodetips')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="2 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div> -->
      </div>
      <!-- 支付宝 -->
      <div v-show="bank.type == 2">
        <div class="item">
          <div class="ari_font">
            支付宝账号：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            placeholder="请输入支付宝账号"
          >
        </div>
        <div class="qrcode">
          <div>支付宝收款码</div>
          <div class="qrcode_img">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="1"
              class="upload"
              :max-size="2 * 1024 * 1024"
              :after-read="afterRead"
              :before-read="beforeRead"
              @oversize="onOversize"
            />
          </div>
        </div>
      </div>
      <!-- 微信 -->
      <div v-show="bank.type == 3">
        <div class="item">
          <div class="ari_font">
            微信号：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            placeholder="请输入微信号"
          >
        </div>
        <div class="qrcode">
          <div>微信收款码</div>
          <div class="qrcode_img">
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="1"
              class="upload"
              :max-size="2 * 1024 * 1024"
              :after-read="afterRead"
              :before-read="beforeRead"
              @oversize="onOversize"
            />
          </div>
        </div>
      </div>
      <!-- 银行卡 -->
      <div v-show="bank.type == 4">
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.name') }}：
          </div>
          <input
            v-model="bank.name"
            class="card"
            type="text"
            :placeholder="$t('invest_bank.namein')"
          >
        </div>
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.account') }}：
          </div>
          <input
            v-model="bank.account"
            class="card"
            type="text"
            :placeholder="$t('invest_bank.accountin')"
          >
        </div>
        <div class="item">
          <div class="ari_font">
            {{ $t('invest_bank.bank') }}：
          </div>
          <input
            v-model="bank.area"
            class="card"
            type="text"
            :placeholder="$t('invest_bank.bankin')"
          >
        </div>
      </div>
    </div>
    <div
      class="basic_btn wallet-submit"
      @click="submitBtn"
    >
      {{ $t('account.submit') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import {
        Overlay,Uploader,Button,DropdownMenu, DropdownItem,Toast
    } from 'vant';
    import axios from 'axios'

    Vue.use(Overlay).use(Uploader).use(Button).use(DropdownMenu).use(DropdownItem);
    export default {
        name: "AddcountUsdt",
        data() {
            return {
                bank: {
                    account: '',
					name:'',
                    area: '',
                    bank:'',
					img:'',
					type:1,
					wid:0
                },
				fileList: [],
				type:1,
				value:0,
				wallets:[]
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			start(){
				Fetch('/user/wallet_type',{
				}).then(r=>{
					this.bank.bank = r.data[0].name;
					this.bank.type = r.data[0].type;
					this.bank.wid = r.data[0].id;
					for (let i = 0; i < r.data.length; i++) {
						this.wallets.push({
						    text: r.data[i].name,
						    value: i,
							type:r.data[i].type,
							wid:r.data[i].id
						})
					}
				})
			},
            submitBtn(){
				if (!this.bank.account) {
				    this.$notify(this.$t('account.addressEmpty'));
				    return;
				}
				 // 定义波场地址的正则表达式
			// 	var tronAddressRegex = /^(T[1-9A-HJ-NP-Za-km-z]{33})$/;
			
			// 	  // 使用正则表达式测试输入的钱包地址
			// 	if (!tronAddressRegex.test(this.bank.account)) {
			// 		this.$notify(this.$t('shopd.trcaddrerr'));
			// 		return;
			// 	} 
				// if (!this.bank.img) {
				//     this.$notify(this.$t('account.qrcodeEmpty'));
				//     return;
				// }
                Fetch('/user/bank_add',{
                    ...this.bank
                }).then(()=>{
					this.$router.go(-1);
                })
            },
			onOversize() {
			    this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
			    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
			        this.$toast(this.$t('account.supportPicture'));
			        return false;
			    }
			    return true;
			},
			afterRead(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.bank.img = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			onChange(){
				this.type = this.wallets[this.value]['type'];
				this.bank.bank = this.wallets[this.value]['text'];
				this.bank.type = this.wallets[this.value]['type'];
				this.bank.wid = this.wallets[this.value]['wid'];
			}
            
        }
    };
</script>

<style lang="less" scoped>
	// /deep/ .van-overlay{
	// 	background-color:hsla(0,0%,100%,0);
	// }
 //    /deep/ .van-dropdown-menu {
 //        position: relative;
	// 	width: 100%;
 //        z-index: 10;
 //        color: #CCCCCC;
 //    }

    /deep/ .van-dropdown-menu__bar {
		box-shadow:none;
        // position: relative;
        // z-index: 10;
        // height: 34px;
        // border: 1px solid #D9D9D9;
        // border-radius: 4px;
        // text-align: left;
    }
 //    /deep/ .van-dropdown-item--down {
 //        margin: 0 auto;
 //        z-index: 12;
 //        transform: translateX(4px);
 //    }

    // /deep/ .van-dropdown-menu__item {
    //     justify-content: flex-start;
    //     color: #ccc;
    //     background-color: #fff;
    // }

 //    /deep/ .van-dropdown-menu__title {
 //        width: 100%;
 //    }

 //    /deep/ .van-dropdown-menu__title::after {
 //        width: 13px;
 //        height: 22px;
 //        transform: none;
 //        background: url(../../assets/images/drop.png) no-repeat center center;
 //        background-size: 100% 100%;
 //        border: none;
 //        opacity: 1;
 //        margin-top: -11px;
 //        right: 10px;
 //    }

 //    /deep/ .van-cell {
 //        padding: 5px 8px;
 //    }

 //    /deep/ .van-cell__title {
 //        flex: 3;
 //        white-space: normal;
 //    }

 //    /deep/ .van-ellipsis {
 //        color: #000;
 //    }

 //    /deep/ .van-dropdown-item__option {
 //        color: #ccc;
 //        border: 1px solid #D9D9D9;
 //        border-bottom: none;
 //        border-radius: 4px;
 //    }

 //    /deep/ .van-dropdown-item__option:last-child {
 //        border-bottom: 1px solid #D9D9D9;
 //    }

 //    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
 //        color: #000;

 //        .van-dropdown-item__icon {
 //            color: #E96259;
 //        }
 //    }
	/deep/ .van-button--primary {
	    background-color: transparent;
	    border: none;
	    width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__input-wrapper {
	    width: 100%;
	}
	/deep/ .van-uploader__wrapper{
		width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__upload{
		width: 100%;
		height: 100%;
		margin:0;
	}
	/deep/ .van-uploader__preview{
		margin:0;
	}
	/deep/ .van-uploader__preview-image{
		width: 100%;
		height: 100%;
	}
	
    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
		margin: 10px;
        margin-top: 12px;
        .item {
            height: 50px;
            padding: 0 16px;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }
			.card{
				width: 100%;
			}
            input {
                line-height: 14px;
            }
        }
    }

    .ari_font {
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 75px auto 0 auto;
    }
	.qrcode{
		padding-top: 30px;
		padding-bottom: 30px;
		text-align: center;
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 20px;
		}
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 250px;
			height: 250px;
			margin: 0 auto;
			background: linear-gradient(to left, #999, #999) left top no-repeat, 
						linear-gradient(to bottom, #999, #999) left top no-repeat, 
						linear-gradient(to left, #999, #999) right top no-repeat,
						linear-gradient(to bottom, #999, #999) right top no-repeat, 
						linear-gradient(to left, #999, #999) left bottom no-repeat,
						linear-gradient(to bottom, #999, #999) left bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
			span{
				line-height: 220px;
			}
			img{
				width: 240px;
				height: 240px;
				position: relative;
				top: -255px;
			}
		}
	}
	::placeholder {
		color: #727d91 !important; /* 设置你想要的颜色 */
	}
	
	/deep/ .van-dropdown-menu__title::after {
	    width: 8px;
	    height: 8px;
	    border-color: transparent transparent #727d91 #727d91;
		right: -18px;
		margin-top: -10px;
	}
	/deep/ .van-dropdown-menu__title--down::after {
		margin-top: -1px !important;
		-webkit-transform: rotate(135deg);
		transform: rotate(135deg);
	}
	/deep/ .van-dropdown-menu__bar{
		background-color: transparent;
	}
	/deep/ .van-dropdown-item--down{
		margin: 0 10px;
	}
	/deep/ .van-dropdown-item__option--active{
		color: #fff;
	}
	/deep/ .van-dropdown-item__option--active .van-dropdown-item__icon{
		color: #fff;
	}
	/deep/ .van-cell{
		background-color: #727d91;
	}
.finance-page {
	min-height: 100vh;
	padding-bottom: .48rem;
	box-sizing: border-box;
}

.finance-page .red_top_bg {
	height: 1.28rem;
	background: transparent;
	color: #222;
}

.finance-page .big_tit {
	top: .42rem;
	color: #222;
	font-size: .34667rem;
	font-weight: 700;
}

.finance-page .back_left {
	position: absolute;
	top: .3rem;
	left: .28rem;
	width: .48rem;
	height: .48rem;
	margin: 0;
	background: none;
}

.finance-page .back_left::after {
	color: #222;
	content: '‹';
	font-size: .64rem;
	font-weight: 300;
	line-height: .4rem;
}

.finance-page .warp1 {
	margin: .08rem .4rem 0;
	padding: .08rem .32rem;
	border: .02667rem solid #ececec;
	border-radius: .26667rem;
	background: #fff;
	box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .04);
}

.finance-page .warp1 .item {
	min-height: 1rem;
	height: auto;
	padding: .2rem .08rem;
	border-color: #f0f0f0;
	box-sizing: border-box;
}

.finance-page .ari_font {
	width: 1.52rem;
	color: #484848;
	font-size: .26667rem;
	font-weight: 600;
}

.finance-page .warp1 .item input {
	width: 100%;
	height: .56rem;
	border: 0;
	color: #222;
	font-size: .26667rem;
	line-height: .56rem;
}

.finance-page /deep/ .van-dropdown-menu {
	width: 100%;
}

.finance-page /deep/ .van-dropdown-menu__bar {
	height: .56rem;
	background: transparent;
}

.finance-page /deep/ .van-dropdown-menu__title {
	color: #3b3b3b;
	font-size: .26667rem;
}

.finance-page /deep/ .van-dropdown-item__option,
.finance-page /deep/ .van-cell {
	background: #fff;
	color: #3b3b3b;
}

.finance-page .qrcode {
	padding: .32rem 0;
	color: #717171;
	font-size: .24rem;
}

.finance-page .qrcode .qrcode_img {
	width: 3.4rem;
	height: 3.4rem;
	border-radius: .16rem;
}

.finance-page .basic_btn {
	width: calc(100% - .8rem);
	height: .96rem;
	margin: .4rem .4rem 0;
	border-radius: .2rem;
	background: #ff385c;
	box-shadow: 0 .13333rem .24rem rgba(255, 56, 92, .22);
	color: #fff;
	font-size: .32rem;
	font-weight: 600;
	line-height: .96rem;
}

/* Wallet setup: retain the original form flow, while presenting it as a concise financial profile. */
.wallet-add-page {
	position: relative;
	min-height: 100vh;
	padding: .24rem .32rem .8rem;
	box-sizing: border-box;
}

.wallet-add-page .wallet-header {
	position: relative;
	height: 1.76rem;
	padding: 0;
	overflow: hidden;
	border-radius: .28rem;
	background: linear-gradient(135deg, #17273d, #2d4665);
	box-shadow: 0 .18rem .38rem rgba(18, 35, 57, .18);
}

.wallet-add-page .wallet-header::before {
	position: absolute;
	top: -.82rem;
	right: -.32rem;
	width: 2.1rem;
	height: 2.1rem;
	border: .01333rem solid rgba(255, 255, 255, .2);
	border-radius: 50%;
	box-shadow: -.28rem .44rem 0 -.18rem rgba(255, 186, 69, .95);
	content: '';
}

.wallet-add-page .wallet-header .back_left {
	z-index: 1;
	top: .24rem;
	left: .24rem;
	width: .52rem;
	height: .52rem;
	border-radius: 50%;
	background: rgba(255, 255, 255, .13);
}

.wallet-add-page .wallet-header .back_left::after {
	color: #fff;
	font-size: .58rem;
	line-height: .44rem;
}

.wallet-add-page .wallet-header .big_tit {
	position: relative;
	z-index: 1;
	top: .63rem;
	padding: 0 .34rem;
	color: #fff;
	font-size: .37333rem;
	font-weight: 700;
	letter-spacing: .01rem;
	text-align: left;
}

.wallet-add-page .wallet-form {
	position: relative;
	margin: -.22rem 0 0;
	padding: .12rem .34rem .04rem;
	overflow: hidden;
	border: .01333rem solid rgba(255, 255, 255, .85);
	border-radius: .28rem;
	background: rgba(255, 255, 255, .97);
	box-shadow: 0 .2rem .42rem rgba(28, 42, 61, .12);
}

.wallet-add-page .wallet-form::before {
	position: absolute;
	top: .22rem;
	left: .34rem;
	width: .56rem;
	height: .07333rem;
	border-radius: .08rem;
	background: #ff385c;
	content: '';
}

.wallet-add-page .wallet-form .item {
	min-height: 1.14rem;
	padding: .22rem 0;
	border-bottom: .01333rem solid #edf0f4;
}

.wallet-add-page .wallet-form > .item:first-child {
	padding-top: .42rem;
}

.wallet-add-page .wallet-form .ari_font {
	width: 1.62rem;
	color: #29384c;
	font-size: .26667rem;
	font-weight: 600;
}

.wallet-add-page .wallet-form .item input {
	flex: 1;
	width: auto;
	height: .62rem;
	padding: 0;
	border: 0;
	color: #15253a;
	font-size: .28rem;
	line-height: .62rem;
	text-align: right;
	outline: none;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu {
	flex: 1;
	width: auto;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu__bar {
	height: .62rem;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu__item {
	justify-content: flex-end;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu__title {
	padding-right: .34rem;
	color: #15253a;
	font-size: .28rem;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu__title::after {
	right: 0;
	border-color: transparent transparent #78879a #78879a;
}

.wallet-add-page .wallet-form .qrcode {
	padding: .38rem 0 .3rem;
	color: #526276;
	font-size: .25333rem;
}

.wallet-add-page .wallet-form .qrcode_img {
	border-radius: .2rem;
	background-color: #f8f9fb;
}

.wallet-add-page .wallet-submit {
	width: 100%;
	height: 1rem;
	margin: .34rem 0 0;
	border-radius: .2rem;
	background: linear-gradient(105deg, #ff4a68, #e8214c);
	box-shadow: 0 .16rem .28rem rgba(232, 33, 76, .24);
	font-size: .32rem;
	font-weight: 700;
	letter-spacing: .02rem;
	line-height: 1rem;
}

/* Wallet setup follows the same calm financial layout as the withdrawal gateway. */
.wallet-add-page {
	min-height: 100vh;
	padding: 0 0 72px;
	box-sizing: border-box;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
	font-size: 14px;
}

.wallet-add-page .wallet-header {
	height: 50px;
	border: 0;
	border-bottom: 1px solid rgba(235, 235, 235, .9);
	border-radius: 0;
	background: rgba(255, 255, 255, .9);
	box-shadow: none;
	backdrop-filter: blur(10px);
}

.wallet-add-page .wallet-header::before {
	display: none;
}

.wallet-add-page .wallet-header .big_tit {
	top: 0;
	height: 50px;
	padding: 0;
	color: #202b3d;
	font-size: 16px;
	line-height: 50px;
	text-align: center;
}

.wallet-add-page .wallet-header .back_left {
	top: 0;
	left: 0;
	width: 44px;
	height: 50px;
	border-radius: 0;
	background: none;
}

.wallet-add-page .wallet-header .back_left::after {
	position: absolute;
	top: 18px;
	left: 17px;
	width: 11px;
	height: 11px;
	border-bottom: 2px solid #26364e;
	border-left: 2px solid #26364e;
	color: transparent;
	content: '';
	transform: rotate(45deg);
}

.wallet-add-page .wallet-form {
	margin: 16px;
	padding: 4px 14px;
	border: 1px solid rgba(255, 255, 255, .96);
	border-radius: 16px;
	background: rgba(255, 255, 255, .97);
	box-shadow: 0 8px 22px rgba(35, 50, 73, .08);
}

.wallet-add-page .wallet-form::before {
	top: 0;
	left: 16px;
	width: 36px;
	height: 3px;
	border-radius: 0 0 3px 3px;
}

.wallet-add-page .wallet-form .item,
.wallet-add-page .wallet-form > .item:first-child {
	min-height: 58px;
	padding: 10px 2px;
}

.wallet-add-page .wallet-form .ari_font {
	width: 108px;
	font-size: 14px;
	line-height: 1.4;
}

.wallet-add-page .wallet-form .item input {
	height: 38px;
	font-size: 14px;
	line-height: 38px;
}

.wallet-add-page .wallet-form .item input::placeholder {
	color: #8b96a5 !important;
	font-size: 14px;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu__bar {
	height: 38px;
}

.wallet-add-page .wallet-form /deep/ .van-dropdown-menu__title {
	font-size: 14px;
}

.wallet-add-page /deep/ .van-dropdown-item--down {
	margin: 0 16px;
	overflow: hidden;
	border-radius: 0 0 14px 14px;
	box-shadow: 0 12px 26px rgba(28, 42, 61, .16);
}

.wallet-add-page /deep/ .van-dropdown-item__content {
	border: 1px solid #e8edf3;
	border-top: 0;
	border-radius: 0 0 14px 14px;
	background: #fff;
}

.wallet-add-page /deep/ .van-dropdown-item__option,
.wallet-add-page /deep/ .van-cell {
	min-height: 54px;
	padding: 14px 16px;
	background: #fff;
	color: #29384c;
	font-family: inherit;
	font-size: 14px;
	line-height: 20px;
}

.wallet-add-page /deep/ .van-dropdown-item__option--active {
	background: #fff4f6;
	color: #df2352;
}

.wallet-add-page /deep/ .van-dropdown-item__option--active .van-dropdown-item__icon {
	color: #df2352;
}

.wallet-add-page /deep/ .van-overlay {
	background-color: transparent;
}

.wallet-add-page .wallet-form .qrcode {
	font-size: 12px;
	line-height: 1.5;
}

.wallet-add-page .wallet-submit {
	width: calc(100% - 32px);
	height: 48px;
	margin: 14px 16px 0;
	border-radius: 12px;
	background: linear-gradient(96deg, #ff4d72, #d81f62);
	box-shadow: 0 8px 18px rgba(216, 31, 98, .22);
	font-size: 16px;
	line-height: 48px;
}
</style>
